"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = PageButtons;
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _Pagination = require("./Pagination.utils");
var _messages = require("./messages");
// Expecting buildButtonsArray (function), and clickHandler (function) from props
function PageButtons(props) {
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "PageButtons"
  }, (0, _Pagination.getPageButtons)(props.currentPage, props.totalPages).map((currentButton, index) => {
    // Dynamically toggle 1 or more classes based on state
    let buttonClass = (0, _classnames.default)({
      "PageButtons-button": !currentButton.isEllipsis,
      "PageButtons-ellipsis": currentButton.isEllipsis,
      "current": currentButton.isCurrent,
      "t-body-med": !currentButton.isCurrent,
      "t-label-large": currentButton.isCurrent
    });
    if (!currentButton.isEllipsis) {
      const alt = currentButton.isCurrent ? _messages.messages[props.language].onpage : _messages.messages[props.language].page;
      // Put a numbered button on the page
      return /*#__PURE__*/_react.default.createElement("button", {
        "aria-label": `${alt.replace("{0}", currentButton.content).replace("{1}", props.totalPages)}`,
        className: buttonClass,
        key: currentButton.content + "-" + index,
        onClick: () => {
          props.clickHandler(parseInt(currentButton.content, 10));
        }
      }, currentButton.content);
    } else {
      // Put a non-clickable ellipsis marker on the page
      return /*#__PURE__*/_react.default.createElement("span", {
        className: buttonClass,
        key: currentButton.content + "-" + index
      }, "\u2026");
    }
  }));
}